import { useQuery, QueryResult } from '@apollo/client';
import { useRouter } from 'next/router';
// Hocks
import { useRedirectOnError } from 'hooks';
// Api
import { GET_MEMORABILIA_BY_SLUG } from 'api/memorabilia/queries';
// Types
import {
  GetMemorabiliaBySlug,
  GetMemorabiliaBySlugVariables,
} from 'api/memorabilia/types/GetMemorabiliaBySlug';

export const useGetMemorabiliaBySlug = (): QueryResult<
  GetMemorabiliaBySlug,
  GetMemorabiliaBySlugVariables
> => {
  const router = useRouter();
  const { memorabiliaSlug, athleteSlug } = router.query;
  // Extract only the slug part before any query parameters
  const cleanMemorabiliaSlug = (memorabiliaSlug as string)?.split('?')[0];

  const data = useQuery<GetMemorabiliaBySlug, GetMemorabiliaBySlugVariables>(
    GET_MEMORABILIA_BY_SLUG,
    {
      variables: {
        slug: cleanMemorabiliaSlug,
        storeSlug: athleteSlug as string,
      },
      skip: !cleanMemorabiliaSlug || !athleteSlug,
    }
  );

  useRedirectOnError({
    error: data.error,
    redirectTo: `/${athleteSlug}/memorabilia`,
  });

  return data;
};
